import { Provider } from 'react-redux';
import { store, persistor } from './reducers/store';
import { PersistGate } from 'redux-persist/integration/react';
import Routes from './router'

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Routes />
      </PersistGate>
    </Provider>
  );
};

export default App;